import { Skeleton } from '@ordo/ui/skeleton'
import { useEffect } from 'react'
import { Navigate } from 'react-router'
import { useAuthStore } from 'stores/auth'

export function UnauthRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user)
  const loading = useAuthStore((s) => s.loading)
  const lastFetchedAt = useAuthStore((s) => s.lastFetchedAt)
  const fetchUser = useAuthStore((s) => s.fetchUser)

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  // Initial load — haven't fetched yet
  if (lastFetchedAt < 0 && loading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Skeleton className="h-8 w-48" />
      </div>
    )
  }

  // User is present — redirect away from login
  if (user && !loading) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
